import React, { useState } from 'react';

const PortalAuth = ({ onAuthenticated, clientName }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const hashPassword = async (password) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const hash = await hashPassword(password);
      const isValid = await onAuthenticated(hash);
      
      if (!isValid) {
        setError('Invalid password. Please try again.');
        setPassword('');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="portal-auth-container">
      <div className="portal-auth-box">
        <div className="portal-auth-header">
          <h1>Government Client Portal</h1>
          <p className="portal-auth-subtitle">{clientName}</p>
        </div>
        
        <div className="portal-auth-content">
          <p className="portal-auth-message">
            This portal contains confidential project documentation prepared for government procurement review.
          </p>
          
          <form onSubmit={handleSubmit} className="portal-auth-form">
            <div className="portal-auth-field">
              <label htmlFor="password">Access Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter portal password"
                autoFocus
                disabled={isLoading}
              />
            </div>
            
            {error && <div className="portal-auth-error">{error}</div>}
            
            <button 
              type="submit" 
              className="portal-auth-button"
              disabled={isLoading || !password}
            >
              {isLoading ? 'Verifying...' : 'Access Portal'}
            </button>
          </form>
        </div>
        
        <div className="portal-auth-footer">
          <p className="portal-branding">Powered by <span>Omnigeist</span></p>
        </div>
      </div>
    </div>
  );
};

export default PortalAuth;

